export default {
  namespaced: true,
  actions: {
    create({ commit, dispatch }, flag) {
      return Vue.$http.post('client/flags', { ...flag }).then(
        ({ data }) => data,
        error => {
          throw error
        }
      )
    },
  },
}
